module.exports = __webpack_public_path__ + "static/media/buyers_banner.2577d55e.jpg";